import {Asteroid} from '../game-objects/Asteroid/Asteroid';
import {Cometa} from '../game-objects/Cometa/Cometa';

import {Point2d, ViewParticle} from '@specials/particle-emitter';

export class GameObjectAdapter implements ViewParticle {
  constructor(public readonly gameObject: Asteroid | Cometa) {}

  set x(v: number) {
    this.gameObject.transformComponent.x = v;
  }

  get x(): number {
    return this.gameObject.transformComponent.x;
  }

  set y(v: number) {
    this.gameObject.transformComponent.y = v;
  }

  get y(): number {
    return this.gameObject.transformComponent.y;
  }

  get scale(): Point2d {
    return {
      x: this.gameObject.transformComponent.scale.x,
      y: this.gameObject.transformComponent.scale.y,
    };
  }

  set scale(v: Point2d) {
    this.gameObject.transformComponent.scale.x = v.x;
    this.gameObject.transformComponent.scale.y = v.y;
  }

  get alpha(): number {
    return this.gameObject.viewComponent.view.alpha;
  }

  set alpha(alpha: number) {
    this.gameObject.viewComponent.view.alpha = alpha;
  }

  get tint(): string | number {
    return this.gameObject.viewComponent.view.tint;
  }

  set tint(tint: string | number) {
    this.gameObject.viewComponent.view.tint = tint;
  }

  get angle(): number {
    return this.gameObject.viewComponent.view.angle;
  }

  set angle(angle: number) {
    this.gameObject.viewComponent.view.angle = angle;
  }

  get width(): number {
    return this.gameObject.viewComponent.view.width;
  }

  set width(width: number) {
    this.gameObject.viewComponent.view.width = width;
  }

  get height(): number {
    return this.gameObject.viewComponent.view.height;
  }

  set height(height: number) {
    this.gameObject.viewComponent.view.height = height;
  }

  get destroyed(): boolean {
    return this.gameObject.isMarkedAsDestroyed;
  }

  set destroyed(isDestroyed: boolean) {
    if (isDestroyed) {
      this.gameObject.setAsDestroyed();
    }
  }

  get visible(): boolean {
    return this.gameObject.viewComponent.view.visible;
  }

  set visible(value: boolean) {
    this.gameObject.viewComponent.view.visible = value;
  }
}
